
import { computed, defineComponent, ref } from "vue";
import BaseSvg from "@/components/base/BaseSvg.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import { useRoute } from "vue-router";
import MyBookings from "./booking/AccountMyBookings.vue";
import AccountHeader from "./AccountHeader.vue";
import AccountSettings from "./accountsettings/AccountSettings.vue";
import { Component } from "@/models/enums";
import useAccountPages from "@/composables/useAccountPages";
import useAccountNavigation from "@/composables/useAccountNavigation";
import BaseButton from "../base/BaseButton.vue";

export default defineComponent({
	components: {
		BaseSvg,
		BaseSection,
		BaseSpinner,
		MyBookings,
		AccountHeader,
		AccountSettings,
		BaseButton,
	},
	async setup() {
		const route = useRoute();
		const loading = ref(false);

		const { isLoggedIn } = useAccountPages();
		const { accountLoading } = useAccountNavigation();
		
		const activeComponent = computed(() => {
			switch (route.query.p) {
				case "1":
					return Component[Component.MyBookings];
				case "2":
					return Component[Component.AccountSettings];
				default:
					return Component[Component.MyBookings];
			}
		});

		await isLoggedIn();

		return {
			loading,
			activeComponent,
			accountLoading,
		};
	},
});
